import { IApplicationState, TBoardId, TCardId } from '../../../../types/types';
import { getBoard } from '../../../../store/model/selectors/getBoardById';
import { getList } from '../../../../store/model/list/selectors/getList';
import { getCard } from '../../../../store/model/selectors/getCard';
import { TStatus } from '../../../../types/model';

export const getEpicIds = (
    state: IApplicationState,
    boardId: TBoardId
): TCardId[] => {
    const board = getBoard(state, boardId);
    if (
        !board ||
        !board.listIds ||
        !board.listIds.length
    ) return [];

    const epicIds = board.listIds.reduce((arr, listId) => {
        const list = getList(state, listId);
        if (
            !list ||
            !list.cardIds ||
            !list.cardIds.length
        ) return arr;

        list.cardIds.forEach((cardId) => {
            const card = getCard(state, cardId);
            if (
                card &&
                card.status !== TStatus.STATUS_DELETED &&
                card.epicId &&
                !arr.includes(card.epicId)
            ) {
                arr.push(card.epicId);
            }
        });
        return arr;
    }, []);
    return epicIds;
}
